import { ProductToInsert } from "@CommonApi/merchflow/_merchflowId_/flow-update";
import { FlowUpdateProduct } from "@CommonApi/merchflow/_merchflowId_/flow-update/products";

export const getFacings = (facings: string): ProductToInsert["facings"] => {
  if (!facings || facings === "AUTO") return "AUTO";
  return Number(facings);
};

export const productToReadableFormat = (product: FlowUpdateProduct) =>
  `${product.productCode} - ${product.name}`;

export const filterProducts = (products: FlowUpdateProduct[], search: string) => {
  return products
    .filter((product) =>
      search.length > 0
        ? product.productCode.toLowerCase().includes(search.toLowerCase()) ||
          product.name.toLowerCase().includes(search.toLowerCase())
        : true,
    )
    .sort((product1, product2) => (product1.productCode < product2.productCode ? -1 : 1));
};
